import script from "./wSubmitButton.vue?vue&type=script&setup=true&lang=js"
export * from "./wSubmitButton.vue?vue&type=script&setup=true&lang=js"

import "./wSubmitButton.vue?vue&type=style&index=0&id=09aa3ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09aa3ace"]])

export default __exports__